/* eslint-disable spaced-comment, max-len, no-console */
import environmentsByEnv from './environments.js'
import overrides from './overrides.js'

const ENV = process.env.NODE_ENV || 'development'

const s = x => JSON.stringify(x)
const isEnv = env => env === ENV

const DEFAULT_PORT = '7700'

const port = process.env.PORT || DEFAULT_PORT

// ========================================================
// Default Configuration
// ========================================================
const config = {
  env: ENV,

  // ----------------------------------
  // Project Structure
  // ----------------------------------

  bugsnag_api_key: 'not-connected',

  // ----------------------------------
  // Server Configuration
  // ----------------------------------
  url_api: process.env.URL_API || '/v1',
  server_host: process.env.DOMAIN ? process.env.DOMAIN : process.env.IE ? '10.0.2.2' : 'localhost',
  server_port: process.env.DEV_SERVER_PORT ? process.env.DEV_SERVER_PORT : process.env.IE ? '4000' : port,

  // ----------------------------------
  // Compiler Configuration
  // ----------------------------------
  compiler_css_modules: false,
  compiler_devtool: process.env.SOURCE_MAP ? process.env.SOURCE_MAP : 'source-map',
  compiler_hash_type: 'hash',
  compiler_fail_on_warning: false,
  compiler_quiet: false,
  compiler_public_path: '/',
  compiler_stats: process.env.COMPILER_STATS || {
    assets: false,
    children: false,
    chunkModules: false,
    chunks: false,
    colors: true,
    hash: false,
    timings: true,
    version: false,
  },
}

/************************************************
 -------------------------------------------------
 All Internal Configuration Below
 Edit at Your Own Risk
 -------------------------------------------------
 ************************************************/

// ------------------------------------
// Environment
// ------------------------------------
// N.B.: globals added here must _also_ be added to .eslintrc

const devMode = ['development', 'webpack'].includes(ENV)

config.globals = {
  'process.env': {
    NODE_ENV: s(ENV),
    BROWSER: s(true),
  },
  NODE_ENV: ENV,
  __DOMAIN__: s(process.env.DOMAIN || 'localhost'),
  __ENV_DEV__: devMode,
  __ENV_PRE__: isEnv('pre_production'),
  __ENV_PROD__: isEnv('production'),
  __URL_API__: s(config.url_api),
}

// ========================================================
// Environment Configuration
// ========================================================
console.debug(`Environment overrides for NODE_ENV "${ENV}"`)
const environment = environmentsByEnv[ENV] || (() => ({}))

export default { ...config, ...environment(config), ...overrides(config) }
